/* START_MODULE_CONTRACT
 * PURPOSE: Шаг 1 регистрации: ввод email и запуск отправки кода подтверждения.
 * SCOPE: React-компонент формы в стиле auth-страниц.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * RegisterStepEmail - шаг ввода email при регистрации.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Кастомная форма в стиле auth-страниц вместо MUI.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import { registerInit } from '../../api/authApi';

/* START_METHOD_RegisterStepEmail */
/* START_CONTRACT: RegisterStepEmail
 * PURPOSE: Шаг 1 регистрации: ввод email и запуск отправки кода подтверждения.
 * INPUTS: { email: string, setEmail: (v)=>void, onNext: ()=>void }.
 * OUTPUTS: { JSX.Element - форма }.
 * SIDE_EFFECTS: HTTP registerInit; переход к следующему шагу.
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_CONTRACT: RegisterStepEmail
 */
export default function RegisterStepEmail({ email, setEmail, onNext }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  /* START_METHOD_handleSubmit */
  /* START_CONTRACT: handleSubmit
   * PURPOSE: Отправить email на init-регистрацию; при успехе перейти дальше, иначе показать ошибку.
   * INPUTS: { e: SubmitEvent }.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: HTTP registerInit; onNext(); setError.
   * LINKS: M-REGISTRATION
   * END_CONTRACT: handleSubmit
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await registerInit(email);
      onNext();
    } catch (err) {
      setError(
        err.response?.data?.message || 'Ошибка при отправке запроса',
      );
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleSubmit */

  return (
    <form onSubmit={handleSubmit} noValidate>
      {error ? (
        <div className="auth-page__alert" role="alert">
          {error}
        </div>
      ) : null}
      <div className="auth-page__field">
        <label className="auth-page__label" htmlFor="register-email">
          Email
        </label>
        <input
          id="register-email"
          className="auth-page__input"
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          autoFocus
          required
        />
      </div>
      <button
        type="submit"
        className="auth-page__submit"
        disabled={loading}
      >
        {loading ? 'Отправка…' : 'Далее'}
      </button>
    </form>
  );
}
/* END_METHOD_RegisterStepEmail */
